module.exports = __webpack_public_path__ + "static/media/big-book.17b51b46.png";